import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem } from '@common/product-card';
import {
  PDPGoodsGroup,
  PDPGoodsGroup_goods_carousel_component_list as ProductItemType,
  VerticalProductCardCarouselContainer,
} from '@domains/pdp-common';

import { PAGE_VIEW_COUNT } from '../../related-stylist-list/services/useRelatedStylistListService';
import { convertProductCardItemsToUxGoodsCardItem, getRanking, isShowRanking } from '../utils/convertProductCardItem';
import { HorizontalProductCarousels } from './carousel/HorizontalProductCarousels';
import { CarouselTitle } from './CarouselTitle';

interface TopRecommendListProps {
  list: PDPGoodsGroup[];
  onImpressionProduct: (item: UxGoodsCardItem, position: number) => void | Promise<void>;
  onClickProduct: (item: UxGoodsCardItem, position: number) => void | Promise<void>;
  onSaveProduct: (checked: boolean, item: UxGoodsCardItem, position: number) => void | Promise<void>;
}

export const TopRecommendList = ({
  list,
  onImpressionProduct,
  onClickProduct,
  onSaveProduct,
}: TopRecommendListProps) => {
  return (
    <>
      {list.map(({ goods_carousel, group_type, main_title, is_ad }) => {
        const items = goods_carousel.component_list.map((item, index) =>
          convertProductCardItemsToUxGoodsCardItem(item, getRanking(isShowRanking(group_type), index)),
        );

        const dividedList: ProductItemType[][] = [];
        for (let i = 0; i < goods_carousel.component_list.length; i += PAGE_VIEW_COUNT) {
          const row: ProductItemType[] = [];
          for (let j = 0; j < PAGE_VIEW_COUNT; j++) {
            if (goods_carousel.component_list[i + j]) {
              row.push(goods_carousel.component_list[i + j]);
            }
          }
          dividedList.push(row);
        }

        const isHorizontal = group_type.includes('horizontal');

        return (
          <TopRecommendWrapper key={group_type}>
            {isHorizontal ? (
              <HorizontalProductCarousels
                list={dividedList}
                title={main_title.text}
                onImpressionProduct={onImpressionProduct}
                onClickProduct={onClickProduct}
                onSaveProduct={onSaveProduct}
              />
            ) : (
              <VerticalProductCardCarouselContainer
                defaultSize='small'
                title={<CarouselTitle title={main_title.text} isAd={is_ad} />}
                items={items}
                onImpression={(item, index) => onImpressionProduct(item, index)}
                onClick={(item, index) => onClickProduct(item, index)}
                onLikeClick={(checked, item, index) => onSaveProduct(checked, item, index)}
              />
            )}
          </TopRecommendWrapper>
        );
      })}
    </>
  );
};

const TopRecommendWrapper = styled.div`
  border-top: 8px solid ${vars.v3Color.gray30};
`;
